/* eslint-disable max-len */ /* eslint-disable padding-line-between-statements */ /* eslint-disable prettier/prettier */ "use strict";
function getEmployees() {
    var collection = document.getElementsByTagName("li");
    var list = [];
    for(var i = 0; i < collection.length; i++)list.push(collection.item(i));
    return list;
}
function sortList(employees) {
    employees.sort(function(employee1, employee2) {
        var salary1 = salaryNormilaze(employee1["attributes"]["data-salary"]["value"]);
        var salary2 = salaryNormilaze(employee2["attributes"]["data-salary"]["value"]);
        // console.log(salary1);
        // console.log(salary2);
        return salary2 - salary1;
    });
    return employees;
}
function salaryNormilaze(salary) {
    var normilaizedSalary = salary.slice(1).split(",").join("");
    // console.log(salary);
    // console.log(normilaizedSalary);
    return parseInt(normilaizedSalary);
}
var listOfEmployees = getEmployees();
var sortedList = sortList(listOfEmployees);
for(var i = 0; i < sortedList.length; i++)document.getElementsByTagName("li")[i].outerHTML = sortedList[i].outerHTML;

//# sourceMappingURL=index.fb1053e4.js.map
